import { Search } from "lucide-react";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "~/components/ui";

interface ConversationHistorySearchInputProps {
  search: string;
  setSearch: (text: string) => void;
}

export const ConversationHistorySearchInput: FunctionComponent<ConversationHistorySearchInputProps> = ({
  search,
  setSearch,
}) => {
  const { t } = useTranslation();

  return (
    <Input
      allowClear
      // Input is `w-full shrink-0`; in this row beside the sort button it must shrink to fit
      className="shrink"
      placeholder={t("conversation:searchPlaceholder")}
      prefix={<Search size={14} />}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  );
};
